import React, { useState, useEffect } from 'react';
import { Slider, Typography, Box } from '@mui/material';

const PremiumTermSlider = ({ 
  totalTerm,
  alreadyPaidTerm,
  value,
  onInputChange,
  fieldName = 'agreeToPayTerm'
}) => {
  const minPayTerm = parseFloat((alreadyPaidTerm).toFixed(2));
  const maxPayTerm = totalTerm;
  
  // Local state for immediate UI updates
  const [sliderValue, setSliderValue] = useState(value || minPayTerm);
  
  // Generate integer marks from min to max
  const marks = [];
  for (let i = Math.ceil(minPayTerm); i <= maxPayTerm; i++) {
    marks.push({ value: i, label: i.toString() });
  }

  // Sync local state when external value changes
  useEffect(() => {
    setSliderValue(value || minPayTerm);
  }, [value, minPayTerm]);

  const handleChange = (event, newValue) => {
    const numericValue = typeof newValue === 'number' ? newValue : newValue[0];
    // Ensure value stays within bounds
    const clampedValue = Math.max(minPayTerm, Math.min(numericValue, maxPayTerm));
    
    // Update local state immediately
    setSliderValue(clampedValue);
    
    // Propagate change to Formik
    onInputChange({ target: { name: fieldName, value: clampedValue } });
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Select Additional Payment Term
      </Typography>
      
      <Slider
        value={sliderValue}
        onChange={handleChange}
        min={minPayTerm}
        max={maxPayTerm}
        step={1.0} // Still allow decimal precision in selection
        marks={marks}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => v.toFixed(2)} // Show 2 decimal places in tooltip
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Typography variant="body2">
          Already Paid: {alreadyPaidTerm.toFixed(2)} years
        </Typography>
        <Typography variant="body2">
          Additional Selected: {(sliderValue - alreadyPaidTerm).toFixed(2)} years
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant="body2">
          Total Selected: {sliderValue.toFixed(2)} years
        </Typography>
        <Typography variant="body2">
          Remaining: {(maxPayTerm - sliderValue).toFixed(2)} years
        </Typography>
      </Box>
    </Box>
  );
};

export default PremiumTermSlider;